<!--
 * @Author: your name
 * @Date: 2021-03-12 17:27:18
 * @LastEditTime: 2021-07-26 10:05:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\components\Poster.vue
-->
<template>
  <div class="poster">
    <!-- <div class="poster_img" v-for="(item,i) in imgSrc" :key="i">
      <img class="auto-img" :src="item.imageUrl" />
    </div>-->
    <template>
      <!-- :gutter="isPhone ? 20 : 40" -->
      <el-row >
        <el-col
          class="img"
          v-for="(item, index) in imgSrc"
          :key="index"
          :span="
            index < imgSrc.length - 1 && imgSrc.length == 4
              ? 8
              : index < imgSrc.length - 1 && imgSrc.length == 3
              ? 12
              : imgSrc.length - 1 && imgSrc.length == 2
              ? 12
              : 24
          "
        >
          <div class="grid-content bg-purple">
            <img class="auto-img" :src="item.imageUrl" />
          </div>
        </el-col>
      </el-row>
    </template>
  </div>
</template>
<script>
export default {
  name: "Poster",
  props: ["ComponData"],
  data() {
    return {
      imgSrc: "",
      isPhone: document.body.clientWidth < 920,
    };
  },
  created() {
    if (this.ComponData) this.imgSrc = this.ComponData;
  },
  methods: {
    jumpUrl(item) {
      if (item.link) window.open(item.link);
    },
  },
  watch: {
    ComponData(val) {
      if (val) this.imgSrc = val;
    },
  },
};
</script>
<style lang="less" scope>
.poster {
  width: 100%;
  position: relative;
  .poster_img {
    cursor: pointer;
  }
}
</style>
